import { render, staticRenderFns } from "./LocalSSIDCreateForm.vue?vue&type=template&id=5982e6ed&scoped=true"
import script from "./LocalSSIDCreateForm.vue?vue&type=script&lang=js"
export * from "./LocalSSIDCreateForm.vue?vue&type=script&lang=js"
import style0 from "./LocalSSIDCreateForm.vue?vue&type=style&index=0&id=5982e6ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5982e6ed",
  null
  
)

export default component.exports